import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import stilePulsanti from '../../interfaccia/stilePulsanti'
import InputDatoProdotto from "../../modificaProdotti/elementiPagina/InputDatoProdotto";
import _ from "lodash";
import umanizzaDataSenzaOre from "../../interfaccia/funzioniComuni/umanizzaDataSenzaOre";
import apiUrl from "../../Apiurl";
import InputDatoTendinaGenerico from "../../modificaProdotti/elementiPagina/InputDatoTendinaGenerico";
import mouseIMG from '../../files/img/mouse.webp'
import TastoSelezionaTab from "./OrdineComponenti/TastoSelezionaTab"
import ImgArt from "./OrdineComponenti/ImgArt";
import RiquadrinoOrdine from "./OrdineComponenti/RiquadrinoOrdine";
import InputBoolean from "../../modificaProdotti/elementiPagina/InputBoolean";
import Nota from "./OrdineComponenti/Nota";
import Reso from "./OrdineComponenti/Reso";

function ModificaGaranzie({
    garanzia,
    setGaranzia,
    utente,
    datiTendineOrdine,
    setOrdineFunction,
    setVistaConReset
}) {

    const {
        buttonClassesWhite,
        buttonClassesRed,
        buttonClassesGreen,
        classiTastoSblocco,
        vociMenuTabs,
        vociMenuTabsSelezionata,
        inputClassesNOW,
        riquadroClassesRed,
        buttonClassesWhiteNoBorder
    } = stilePulsanti

    let classDivPrincipale = "fixed-l w-100-l sfondoColAlt h-100 colonnaTuttaPagina-ns"

    ///// HOOKS //////////////////

    const [garanziaTemp, setGaranziaTemp] = useState(garanzia);
    const [salvato, setSalvato] = useState(true);
    const [tab, setTab] = useState("note");
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [alert, setAlert] = useState("");
    const [resultSalvataggio, setResultSalvataggio] = useState(false);
    const [alertSalvataggio, setAlertSalvataggio] = useState(false);
    const [arrNoteSottoControllo, setArrNoteSottoControllo] = useState(garanziaTemp.noteArr);


    ///// FUNZIONI ///////////////

    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);

    useEffect(() => {
        setArrNoteSottoControllo(garanziaTemp.noteArr);
    }, [garanziaTemp]);

    const impostaOrdine = (e, idSped) => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }

        fetch(apiUrl + "/logistica/ricerca/ricOrdineCodSpedQuerySep/" + idSped, { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => setOrdineFunction(data || "NO DATA"))
            .then(e.preventDefault())

    }

    async function duplicaOrdine() {
        console.log("duplicato")
        const duplicato = {
            spedEclifor: [{
                ...garanziaTemp.spedEcliforSpedizioneOriginale[0],
                "ID CliFor": null,
                "ID Spedizione": null,
                "Data_inserimento_Spedizione": new Date(),
                "Tipo": "Nuova spedizione",
                "Causale": null,
                "Stato_Ordine": "PREPARAZIONE",
                "Promemoria": 0,
                "Causale_Stato": null,
                "Data": new Date(),
                "N_doc_trasporto": null,
                "Tipo_doc_trasp": "",
                "Data_Preparazione": null,
                "Data_partenza": null,
                "Spese_di_spedizione": null,
                "Spese_di_contrassegno": null,
                "Tipo_di_pagamento": null,
                "Tot_imp_contrassegno": null,
                "Tot_imp_spedizione": null,
                "Emissione_scontrino": null,
                "N_Trakking": null,
                "Reso": 0,
                "statoMag": null,
                "magazzinoStatoMag": null,
                "dataStatoMag": null
            }]
        }

        console.log(duplicato)


        try {
            const data = {
                ordine: duplicato,
                utente: utente.username,
                permessi: utente.permessiAPI
            }
            const dataToSend = JSON.stringify(data);
            let request = new XMLHttpRequest();
            request.open('PATCH', apiUrl + "/logistica/ordine/inserimentoORDINEsingoloQuerySep", true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', 'Bearer ' + token);
            request.send(dataToSend);
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
        try {
            setGaranzia(false);
            setVistaConReset(null,'ordini',apiUrl + "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/",200);
        } catch (err) {
            console.log("Ho salvato e tutto ma mi sono incartato sul chiudere il prodotto: " + err)
            throw err;
        }
    }

    async function duplicaOrdineConArticoli() {
        const duplicato = {
            spedEclifor: [{
                ...garanziaTemp.spedEcliforSpedizioneOriginale[0],
                "ID CliFor": null,
                "ID Spedizione": null,
                "Data_inserimento_Spedizione": new Date(),
                "Tipo": "Nuova spedizione",
                "Causale": null,
                "Stato_Ordine": "PREPARAZIONE",
                "Promemoria": 0,
                "Causale_Stato": null,
                "Data": new Date(),
                "N_doc_trasporto": null,
                "Tipo_doc_trasp": "",
                "Data_Preparazione": null,
                "Data_partenza": null,
                "Spese_di_spedizione": null,
                "Spese_di_contrassegno": null,
                "Tipo_di_pagamento": null,
                "Tot_imp_contrassegno": null,
                "Tot_imp_spedizione": null,
                "Emissione_scontrino": null,
                "N_Trakking": null,
                "Reso": 0,
                "statoMag": null,
                "magazzinoStatoMag": null,
                "dataStatoMag": null
            }]
        }
        duplicato.articoliArr = garanziaTemp.articoloSpedOriginale.map(art => { return ({ ...art, "ID": null, "ID Spedizione": null, "ID Articoli": null, "ID Articolo": null, "Importo unitario": 0.00 }) })
        console.log(duplicato)
        try {
            const data = {
                ordine: duplicato,
                utente: utente.username,
                permessi: utente.permessiAPI
            }
            const dataToSend = JSON.stringify(data);
            let request = new XMLHttpRequest();
            request.open('PATCH', apiUrl + "/logistica/ordine/inserimentoORDINEsingoloQuerySep", true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', 'Bearer ' + token);
            request.send(dataToSend);
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
        try {
            setGaranzia(false);
            setVistaConReset(null,'ordini',apiUrl + "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/",200);
        } catch (err) {
            console.log("Ho salvato e tutto ma mi sono incartato sul chiudere il prodotto: " + err)
            throw err;
        }
    }

    const handleChange = async function (evt) {
        setSalvato(false);
        const value = evt.target.value;
        try {
            if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
                const update = _.set(_.cloneDeep(garanziaTemp), evt.target.name, value) // METODO RESOURCE EXPENSIVE
                setGaranziaTemp(update)
            } else if (!evt.target.name.includes(".") && !evt.target.name.includes("[")) {
                setGaranziaTemp({
                    ...garanziaTemp,
                    [evt.target.name]: value
                });
            } else {
                setAlert("Errore cambio dato")
            }
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato nestato: " + err)
            throw err;
        }
    }

    const linkMailto = `mailto:${garanziaTemp?.garanzia?.mailRappr}?subject=Rif. Ordine PS ${garanziaTemp?.garanzia?.idSpedPS}${garanziaTemp.garanzia.dataOrd && " del " + umanizzaDataSenzaOre(garanziaTemp.garanzia.dataOrd)} - ${garanziaTemp.garanzia.nomeCliente}
    &body=Buongiorno, siamo stati contattati da un nostro cliente che in data ${garanziaTemp.garanzia.dataOrd && umanizzaDataSenzaOre(garanziaTemp.garanzia.dataOrd)} ha acquistato questo paio di scarpe:%0D%0A
    %0D%0A
        ${garanziaTemp.garanzia["Descrizione Articolo"]}%0D%0A
        %0D%0A
        riscontrando il seguente difetto:%0D%0A
        %0D%0A
        ${garanziaTemp.garanzia.descDifetto}%0D%0A
        %0D%0A
        Allego foto inviate dal cliente. Come possiamo procedere?%0D%0A
        %0D%0A
        In attesa di gentile riscontro porgo cordiali saluti.
        `

    /* const creaSpedRitornoCliente = function () {
        setOrdineFunction({

            spedEclifor: [{
                "ID Spedizione": "NUOVO",
                "Stato_Ordine": "PREPARAZIONE"
            }],
            articoliArr: [],
            resiErimborsiArr: [],
            noteArr: []
        })
    } */

    const creaSpedRitornoFornitore = function () {
        const duplicato = {
            spedEclifor: [{
                ...garanziaTemp.spedEcliforSpedizioneFornitore[0],
                "nomeCliente": garanziaTemp.spedEcliforSpedizioneFornitore[0]["NomeCognome"],
                "ID CliFor": null,
                "ID Spedizione": null,
                "Data_inserimento_Spedizione": new Date(),
                "Tipo": "Servizio interno",
                "Causale": "Conto visione",
                "Stato_Ordine": "PREPARAZIONE",
                "Market_Place": null,
                "Promemoria": 0,
                "Causale_Stato": null,
                "Data": new Date(),
                "N_doc_trasporto": null,
                "Tipo_doc_trasp": "",
                "Data_Preparazione": null,
                "Data_partenza": null,
                "Spese_di_spedizione": null,
                "Spese_di_contrassegno": null,
                "Tipo_di_pagamento": null,
                "Tot_imp_contrassegno": null,
                "Tot_imp_spedizione": null,
                "Emissione_scontrino": null,
                "N_Trakking": null,
                "Reso": 0,
                "statoMag": null,
                "magazzinoStatoMag": null,
                "dataStatoMag": null
            }]
        }
        duplicato.articoliArr = garanziaTemp.articoloSpedOriginale.map(art => { return ({ ...art, "ID": null, "ID Spedizione": null, "ID Articoli": null, "ID Articolo": null, "Importo unitario": 0.00 }) })
        console.log(duplicato)
        try {
            const data = {
                ordine: duplicato,
                utente: utente.username,
                permessi: utente.permessiAPI
            }
            const dataToSend = JSON.stringify(data);
            let request = new XMLHttpRequest();
            request.open('PATCH', apiUrl + "/logistica/ordine/inserimentoORDINEsingoloQuerySep", true);
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Authorization', 'Bearer ' + token);
            request.send(dataToSend);
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
        try {
            setGaranzia(false);
            setVistaConReset(null,'ordini',apiUrl + "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/",200);
        } catch (err) {
            console.log("Ho salvato e tutto ma mi sono incartato sul chiudere il prodotto: " + err)
            throw err;
        }
    }

    async function rimuoviDaArr(arr, i) {
        setSalvato(false);
        const arrUpdate = garanziaTemp[arr];
        arrUpdate.splice(i, 1);
        setGaranziaTemp({
            ...garanziaTemp,
            [arr]: arrUpdate
        });
    }

    async function salvaProdotto(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        if (!garanziaTemp.garanzia.id) {
            ////////////////// NUOVO ORDINE DA INSERIRE PER LA PRIMA VOLTA ///////////////////////////////
            try {
                const data = {
                    garanzia: garanziaTemp,
                    utente: utente.username,
                    permessi: utente.permessiAPI
                }
                const config = {
                    headers: {
                        'Authorization': 'Bearer ' + token,
                    }
                }
                axios.patch(apiUrl + "/logistica/garanzia/salvataggioGARANZIA", data, config)
                    .then((resp) => {
                        if (resp.data.errno) {
                            setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                        } else {
                            setAlertSalvataggio(false)
                            setResultSalvataggio(resp.data)
                            setSalvato(true);
                            setGaranzia(false);
                        }
                    })
            } catch (err) {
                console.log("Errore nell'invio del prodotto alle API': " + err)
                throw err;
            }
        } else {
            //////////////////////////////// ORDINE DA AGGIORNARE ///////////////////////////////////
            try {
                const data = {
                    garanzia: garanziaTemp,
                    utente: utente.username,
                    permessi: utente.permessiAPI,
                    utenteOBJ: utente
                }
                const config = {
                    headers: {
                        'Authorization': 'Bearer ' + token,
                    }
                }
                axios.patch(apiUrl + "/logistica/garanzia/salvataggioGARANZIA", data, config)
                    .then((resp) => {
                        if (resp.data.errno) {
                            setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                        } else {
                            setAlertSalvataggio(false);
                            setResultSalvataggio(resp.data);
                            setSalvato(true);
                            setGaranzia(false);
                        }
                    })

            } catch (err) {
                console.log("Errore nell'invio del prodotto alle API': " + err)
                throw err;
            }
        }
    }

    /* async function rimuoviDaArr(arr,i) {
        setSalvato(false);
        const arrUpdate = garanziaTemp[arr];
        arrUpdate.splice(i,1);
        setGaranziaTemp({
            ...garanziaTemp,
            [arr]: arrUpdate
        });
    } */

    function chiudiSenzaSalvare(e) {
        e.preventDefault()
        setGaranzia(false)
    }

    function cambiaTab(e) {
        e.preventDefault();
        setTab(e.target.id);
    }

    function aggiungiNota() {
        setSalvato(false);
        const notaNuova = {
            nomeUtente: utente.username,
            contenuto: "",
            dataNota: new Date(),
            tipoNota: "fontinaUser"
        }
        setGaranziaTemp({
            ...garanziaTemp,
            noteArr: [...garanziaTemp.noteArr, notaNuova]
        })
    }

    function toDate(stringDate) {
        if (stringDate) {
            var d = new Date(stringDate),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        } else {
            return null
        }
    }

    /* function switchaBoolGenerico(dato, nomeDato) {
        setSalvato(false);
        console.log(dato, nomeDato)
        let value;
        if (dato === 1) {
            value = 0
        } else if (dato === 0 || dato === null) {
            value = 1
        }
        const update = _.set(_.cloneDeep(garanziaTemp), nomeDato, value)
        setGaranziaTemp(update)
    }
 */

    /////////////////////////////////////////// COLONNE /////////////////////////////////////

    function riquadroSalvataggio() {
        return (
            <div>
                {alertSalvataggio && <div className={riquadroClassesRed + " mb2"}>{alertSalvataggio}</div>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdotto}>Salva e chiudi</button>}
                {!salvato && <button className={buttonClassesRed + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi senza salvare</button>}
                {salvato && <button className={buttonClassesGreen + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi</button>}
                {alert && <h3 className="tastoRosso white">{alert}</h3>}
            </div>
        )
    }

    let titolo;

    if (garanziaTemp?.garanzia?.["nomeCliente"]) {
        titolo = garanziaTemp.garanzia["nomeCliente"]
    } else if (garanziaTemp?.garanzia?.["nomeClienteLibero"]) {
        titolo = garanziaTemp.garanzia["nomeClienteLibero"]
    }

    if (garanziaTemp?.garanzia?.idSpedPS) {
        titolo = garanziaTemp.garanzia.idSpedPS.toString().concat(" - ",titolo)
    }

    function riquadroDatiGaranzia() {
        return (
            <div>
                <h2>{titolo}</h2>
                <InputBoolean
                    permessiAPIutente={utente.permessiAPI}
                    permessiAPIRichiesti={"update:database"}
                    oggettoInteroDaModificare={garanziaTemp}
                    setOggetto={setGaranziaTemp}
                    setSalvato={setSalvato}
                    datoBooleano={"garanzia.gestito"}
                    valoreDatoBooleano={garanziaTemp.garanzia.gestito}
                    classnameSeDato1={"tastoVerde white"}
                    classnameSeDato0={""}
                    testoSe1={"GESTITO"}
                    testoSe0={"Clicca per segnalare come gestito"}
                    flexWidth={"w-100"}
                />
                <p>ID {garanziaTemp.garanzia.id}</p>
                {garanziaTemp?.garanzia?.idSpedPS && <div className="mb3">ORDINE PS <strong>{garanziaTemp?.garanzia?.idSpedPS}</strong> DEL {garanziaTemp?.garanzia?.dataOrd && umanizzaDataSenzaOre(garanziaTemp.garanzia.dataOrd)}</div>}
                <div className="flex flex-wrap justify-between">
                    {/* <InputDatoProdotto
                        inputLabel="Cliente"
                        datoName='garanzia["nomeCliente"]'
                        datoId="nomeCliente"
                        datoValue={garanziaTemp?.garanzia?.["nomeCliente"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    /> */}
                    <InputDatoTendinaGenerico
                        inputLabel="Stato Garanzia"
                        datoName='garanzia["statoGaranzia"]'
                        elencoDati={datiTendineOrdine.statoGaranzia}
                        datoId="statoGaranzia"
                        datoValue={garanziaTemp?.garanzia?.["statoGaranzia"] ?? ''}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"} //inserire H-100 nelle altre colonne, e poi capire perché nella prima colonna fa casini
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    {!garanziaTemp?.garanzia?.idSpedPS && <InputDatoProdotto
                        inputLabel="Nome cliente"
                        datoName='garanzia["nomeClienteLibero"]'
                        datoId="nomeClienteLibero"
                        datoValue={garanziaTemp?.garanzia?.["nomeClienteLibero"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />}
                    <InputDatoProdotto
                        inputLabel="Data Garanzia"
                        tipoInput="date"
                        datoName='garanzia.dataRichiestaGaranzia'
                        datoId="dataPart"
                        datoValue={garanziaTemp?.garanzia?.["dataRichiestaGaranzia"] && toDate(garanziaTemp.garanzia["dataRichiestaGaranzia"])}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"} //inserire H-100 nelle altre colonne, e poi capire perché nella prima colonna fa casini
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                        inputLabel="Codice Garanzia"
                        datoName='garanzia["codGaranziaProduttore"]'
                        datoId="codGaranziaProduttore"
                        datoValue={garanziaTemp?.garanzia?.["codGaranziaProduttore"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <div className="flex w-100 items-center">
                        {(garanziaTemp?.garanzia?.["Cod Viglietti Sport"] || garanziaTemp?.garanzia?.codVS || garanziaTemp?.garanzia?.codiceVS || (garanziaTemp?.garanzia?.["imgIDps"] && garanziaTemp?.garanzia?.["prodIDps"])) ?
                            <div className="w-30 mb3">
                                <ImgArt
                                    prodIDps={garanziaTemp.garanzia.prodIDps}
                                    imgIDps={garanziaTemp.garanzia.imgIDps}
                                    fonte={garanziaTemp.garanzia.fonte}
                                    codVS={garanziaTemp.garanzia["Cod Viglietti Sport"] || garanziaTemp.garanzia.codVS || garanziaTemp.garanzia.codiceVS}
                                    token={token}
                                    size="small_default" /><br />
                            </div>
                            : <div className="w-30"></div>
                        }
                        <div className="w-70">
                            {garanziaTemp?.garanzia?.["Descrizione Articolo"]}
                        </div>
                    </div>
                    {(!garanziaTemp?.garanzia?.idSpedPS || !garanziaTemp?.garanzia?.nomeBrand) && <InputDatoProdotto
                        inputLabel="Brand"
                        datoName='garanzia["nomeBrand"]'
                        datoId="nomeBrand"
                        datoValue={garanziaTemp?.garanzia?.["nomeBrand"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    }
                    {(!garanziaTemp?.garanzia?.idSpedPS || !garanziaTemp?.garanzia?.codiceArticolo) && <InputDatoProdotto
                        inputLabel="Codice Articolo"
                        datoName='garanzia["codiceArticolo"]'
                        datoId="codiceArticolo"
                        datoValue={garanziaTemp?.garanzia?.["codiceArticolo"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    }
                    {(!garanziaTemp?.garanzia?.idSpedPS || !garanziaTemp?.garanzia?.nomeArticolo) && <InputDatoProdotto
                        inputLabel="Nome Articolo"
                        datoName='garanzia["nomeArticolo"]'
                        datoId="nomeArticolo"
                        datoValue={garanziaTemp?.garanzia?.["nomeArticolo"] ?? ""}
                        datoPlaceHolder=""
                        datoOnChange={handleChange}
                        inputClass={inputClassesNOW + " w-80"}
                        datoClass={"w-100"}
                        labelClass={"wpx-60"}
                        classiTastoSblocco={classiTastoSblocco}
                        tastoCopiaAspetto="NO"
                        modCompatta="SI"
                        permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    }
                    {/* {!garanziaTemp?.garanzia?.idSpedPS && utente.permessiAPI["update:database"]
                        && <div className="w-100">
                            <label for="noteCorr" className="w-100">Articolo</label>
                            <textarea
                            type="text"
                            rows="5"
                            id="descArticoloLibero"
                            name='garanzia.descArticoloLibero'
                            value={garanziaTemp.garanzia?.descArticoloLibero ?? ""}
                            onChange={handleChange}
                            className={inputClassesNOW + " w-100"} />
                            </div>                        
                    } */}
                    <label for="noteCorr" className="w-100">Descrizione difetto</label>
                    {utente.permessiAPI["update:database"]
                        ? <textarea
                            type="text"
                            rows="5"
                            id="descDifetto"
                            name='garanzia.descDifetto'
                            value={garanziaTemp.garanzia?.descDifetto ?? ""}
                            onChange={handleChange}
                            className={inputClassesNOW + " w-100"} />
                        : <p>{garanziaTemp.garanzia?.descDifetto ?? ""}</p>
                    }
                    {garanziaTemp.garanzia?.istruzioniReso && <div className="w-100 mb2">
                        <h2>Istruzioni per il reso</h2>
                        <div>{garanziaTemp.garanzia.istruzioniReso}</div>
                    </div>}
                    {/* <button className={buttonClassesWhite + " mb2"} onClick={copiaTestoMail}>Crea testo per mail</button> */}
                    <a href={linkMailto} className={buttonClassesWhite + " mt2 mb2"}>manda mail</a>


                </div>
            </div>
        )
    }

    function riquadroOrdiniCollegati(height) {
        return (<div className={"h-" + height + "-ns sfondoColChiaro br4 pa3 tc sezioneConScroll"}>
            <h2 className="tc">Ordini collegati</h2>
            <div className="h-90-ns">
                <div className="mb3">
                {garanziaTemp?.spedEcliforSpedizioneOriginale?.length > 0 && <button className={buttonClassesWhiteNoBorder + " b--white mb3"} onClick={duplicaOrdine}>Crea spedizione per <strong>CLIENTE</strong> - VUOTA</button>}
                {garanziaTemp?.spedEcliforSpedizioneOriginale?.length > 0 && <button className={buttonClassesWhiteNoBorder + " b--white mb3"} onClick={duplicaOrdineConArticoli}>Crea spedizione per <strong>CLIENTE</strong> - STESSO ARTICOLO</button>}
                {garanziaTemp?.spedEcliforSpedizioneFornitore?.length > 0 && <button className={buttonClassesWhiteNoBorder + " b--white mb"} onClick={creaSpedRitornoFornitore}>Crea spedizione per <strong>FORNITORE</strong></button>}
                </div>
            {garanziaTemp?.ordiniCollegatiArr?.length > 0 &&
                garanziaTemp.ordiniCollegatiArr.map((ordine) => <RiquadrinoOrdine
                    ordine={ordine}
                    impostaOrdine={impostaOrdine}
                    mostraIdPS={false}
                    iconaApriOrdineSuCliente
                />)
            }
            </div>
        </div>)
    }

    function riquadroNote(height) {

        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <h3 className="tc">Note</h3>

            {garanziaTemp?.noteArr?.length > 0 && <div className="">{garanziaTemp.noteArr.map((note, i) => <Nota utente={utente} nota={note} handleChange={handleChange} rimuoviDaArr={rimuoviDaArr} i={i} key={i} tabellaNote={"Note_Garanzie"} arrLength={garanziaTemp.noteArr.length} />)}</div>}

            <div className="tc mt4">
                <div className='ba material-icons pa2 br-100 bordoColAlt scrittaColAltScuro pointer' onClick={aggiungiNota}>add</div>
            </div>


        </div>

        )
    }

    function riquadroNoteOrdiniCollegati(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <h3 className="tc">Note negli ordini collegati</h3>
            {garanziaTemp.noteOrdiniArr.length > 0 && garanziaTemp.noteOrdiniArr.map((nota, i) => <Nota nota={nota} utente={utente} handleChange={false} key={i} i={i} rimuoviDaArr={false} tabellaNote={"Note_Spedizioni"} arrLength={garanziaTemp.noteOrdiniArr.length}  />)}
        </div>)
    }

    function riquadroRimborsiOrdiniCollegati(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <h3 className="tc">Rimborsi negli ordini collegati</h3>
            {garanziaTemp.resiErimborsiArr.length > 0 && garanziaTemp.resiErimborsiArr.map((reso, i) => <Reso datiTendineOrdine={datiTendineOrdine} reso={reso} i={i} />)}
        </div>)
    }

    function riquadroObj(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <pre>{JSON.stringify(garanziaTemp, null, 2)}</pre>
        </div>)
    }

    function riquadroObjUtente(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <pre>{JSON.stringify(utente, null, 2)}</pre>
        </div>)
    }

    function riquadroFeedback(height) {
        return (<div className={"h-" + height + "-ns sezioneConScroll"}>
            <pre>{JSON.stringify(resultSalvataggio, null, 2)}</pre>
        </div>)
    }

    function riquadroSceltaTab(height) {
        return (
            <div className="flex flex-wrap">
                <div className="flex dn-ns dn-m">
                    {/* parte dei tasti che si vede solo su mobile */}
                    <TastoSelezionaTab
                        idTasto="chiudi"
                        onClickTasto={salvaProdotto}
                        tab={tab}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                        vociMenuTabs={vociMenuTabs}
                        icona="close"
                        testo="Chiudi"
                    />
                    {/* <TastoSelezionaTab
                        idTasto="ordinePrincipale"
                        onClickTasto={cambiaTab}
                        tab={tab}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                        vociMenuTabs={vociMenuTabs}
                        icona="reorder"
                        testo="Ordine"
                    />
                    <TastoSelezionaTab
                        idTasto="statoOrdine"
                        onClickTasto={cambiaTab}
                        tab={tab}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                        vociMenuTabs={vociMenuTabs}
                        icona="grade"
                        testo="Stato ordine"
                    /> */}
                </div>
                <TastoSelezionaTab
                    idTasto="note"
                    onClickTasto={cambiaTab}
                    tab={tab}
                    vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                    vociMenuTabs={vociMenuTabs}
                    icona="description"
                    testo="Note"
                />
                <TastoSelezionaTab
                    idTasto="rimborsi"
                    onClickTasto={cambiaTab}
                    tab={tab}
                    vociMenuTabsSelezionata={vociMenuTabsSelezionata}
                    vociMenuTabs={vociMenuTabs}
                    icona="payments"
                    testo="Rimborsi"
                />
                <div className="mt3 dn db-ns ">
                    {utente.permessiAPI["read:debug"] && <h3 className={vociMenuTabs + "mt4 pt3 mb3 bt bordoColAlt"}>debug</h3>}
                    {utente.permessiAPI["read:debug"] && <div id="ordineObj" onClick={cambiaTab} className={tab === "ordineObj" ? vociMenuTabsSelezionata : vociMenuTabs}>Oggetto garanzia</div>}
                    {utente.permessiAPI["read:debug"] && <div id="ordineObjUtente" onClick={cambiaTab} className={tab === "ordineObjUtente" ? vociMenuTabsSelezionata : vociMenuTabs}>Oggetto utente</div>}
                    {utente.permessiAPI["read:debug"] && <div id="resImport" onClick={cambiaTab} className={tab === "resImport" ? vociMenuTabsSelezionata : vociMenuTabs}>Feedback salvataggio</div>}
                </div>

                <div className="tr inFondo">
                    {(utente.nomeDisplayAlt === "Manu" || utente.nomeDisplayAlt === "Crack Ribex") && <img alt="topo" className="w-70" src={mouseIMG} />}
                </div>
            </div>)
    }

    //////////////////////////////////////////////////////////////////////////////////

    function colonnaServizio(widthCol1, tab1, hTab1, tab2, hTab2, widthCol2, col2tab1, hCol2Tab1, col2tab2, hCol2Tab2) {
        return (
            <div className="w-100 w-80-ns w-50-l flex flex-wrap h-100">
                <div className={"w-100 w-" + widthCol1 + "-l pa3 bl-ns bordoColAlt h-100"}>
                    <div className=" h-100">
                        {tab1 && tab1(hTab1)}
                        {tab2 && <div className="h-50 bt bordoColAlt dn db-ns">{tab2(hTab2)}</div>}
                    </div>
                </div>
                <div className={"w-100 w-" + widthCol2 + "-l pa3 bl-ns dn db-ns bordoColAlt h-100"}>
                    <div className=" h-100 ">
                        {col2tab1 && col2tab1(hCol2Tab1)}
                        {col2tab2 && <div className="h-50 bt bordoColAlt">{col2tab2(hCol2Tab2)}</div>}
                    </div>
                </div>
            </div>)

    }

    ///// PAGINA


    return (

        <div className={classDivPrincipale}>
            <div className="ma3-ns br4-ns sfondoBiancoTema flex flex-wrap h-100 h-97-ns">
                <div className="w-100 w-20-ns w-50-l flex flex-wrap h-100">
                    <div className="w-100 w-40-l dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns datiOrdine">
                        <div className="colonna85vh sezioneConScroll">
                            {riquadroSalvataggio()}
                            {/* {riquadroDatiOrdine()} */}
                            {riquadroDatiGaranzia()}
                        </div>
                    </div>
                    <div className="w-100 w-40-l dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns statoENote bl-ns bordoColAlt">
                        <div className="colonna85vh pr3">
                            {riquadroOrdiniCollegati(100)}
                            {/* {riquadroStatoOrdine()} */}
                            {/* <div className="bt mt4 pt4 bordoColAlt">
                                {garanziaTemp.garanzia["Stato_Ordine"] !== "IN ATTESA" && riquadroStatoMag(40)}
                                {garanziaTemp.garanzia["Stato_Ordine"] === "IN ATTESA" && riquadroAttese(40)}
                            </div> */}
                        </div>
                    </div>
                    <div className="w-100 w-20-l pl4-ns pt4-ns pb4-ns bl-ns bordoColAlt relative flex justify-center db-ns">
                        {riquadroSceltaTab()}
                    </div>
                </div>
                {/* widthCol1, tab1, hTab1, tab2, hTab2, widthCol2, col2tab1, hCol2Tab1, col2tab2, hCol2Tab2 */}
                {/* {tab === "default" && colonnaServizio(60, riquadroArticoli, 50, riquadroNote, 100, 40, riquadroDatiSpedizioneCliente, 100, false, false)} */}
                {tab === "ordinePrincipale" && colonnaServizio(100, riquadroDatiGaranzia, 100)}
                {tab === "note" && colonnaServizio(60, riquadroNote, 100, false, false, 40, riquadroNoteOrdiniCollegati, 100, false, false)}
                {tab === "rimborsi" && colonnaServizio(50, riquadroRimborsiOrdiniCollegati, 100, false, false, 50, riquadroNote, 100, false, false)}

                {/* {tab === "articoli" && colonnaServizio(60, riquadroArticoli, 100, false, false, 40, riquadroDatiSpedizioneCliente, 100, false, false)}
                {tab === "returnsRefunds" && colonnaServizio(50, riquadroResiRimborsi, 50, riquadroNote, 100, 50, riquadroArticoli, 100, false, false)}
                {tab === "carriers" && colonnaServizio(60, riquadroCorrieri, 100, false, false, 40, riquadroDatiSpedizioneCliente, 100, false, false)}
                {tab === "statoMag" && colonnaServizio(40, riquadroStatoMag, 100, false, false, 60, riquadroCorrieri, 100, false, false)}
                {tab === "tools" && colonnaServizio(40, riquadroTools, 100, false, false, 60, riquadroArticoli, 100, false, false)}
                {tab === "note" && colonnaServizio(60, riquadroNote, 100, false, false, 40, riquadroArticoli, 100, false, false)}
                {tab === "attese" && colonnaServizio(40, riquadroAttese, 50, riquadroResiRimborsi, 50, 60, riquadroNote, 100, false, false)} */}
                {tab === "ordineObj" && colonnaServizio(60, riquadroObj, 100, false, false, 40, riquadroDatiGaranzia, 100, false, false)}
                {tab === "ordineObjUtente" && colonnaServizio(60, riquadroObjUtente, 100, false, false, 40, riquadroDatiGaranzia, 100, false, false)}
                {tab === "resImport" && colonnaServizio(60, riquadroFeedback, 100, false, false, 40, riquadroObj, 100, false, false)}
            </div>
        </div>

    )
}

export default ModificaGaranzie;



